import { init, RematchRootState, RematchDispatch } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import { models, RootModel } from './models/index';

export const store = init<RootModel>({
  models,
  plugins: [immerPlugin()],
});

export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
